import React, { useEffect, useState } from "react";
import "./Policy.scss";
import ReactMarkdown from "react-markdown";
import { useTranslation } from "react-i18next";
import { Breadcrumbs, Layout } from "@netapp/bxp-design-system-react";
import { LangLink } from "../../utils/langNavigation";
import { getContentPath, loadMarkdownContent } from "../../utils/contentLoader";

const Policy = () => {
  const { i18n, t } = useTranslation();
  const [policyData, setPolicyData] = useState({
    frontMatter: {},
    content: "",
  });

  useEffect(() => {
    async function fetchPolicy() {
      try {
        const filePath = getContentPath("/content/policy/_index", i18n.language);
        const { frontMatter, content } = await loadMarkdownContent(filePath);
        setPolicyData({ frontMatter, content });
      } catch (error) {
        console.error("Error fetching policy markdown:", error);
      }
    }
    fetchPolicy();
  }, [i18n.language]);

  const title = policyData.frontMatter?.longtitle || "Policy";
  const slogan = policyData.frontMatter?.slogan || "";
  const description = policyData.frontMatter?.description || "";

  return (
    <div className="policyFrame">
      <Layout.Page>
        <Layout.Content className="content-padding">
          <Layout.BreadcrumbsContainer className="breadcrumb-container">
            <Breadcrumbs>
              <LangLink to="/" className="breadcrumb-link">
                {t("securityPortal.other")}
              </LangLink>
              <div>{title}</div>
            </Breadcrumbs>
          </Layout.BreadcrumbsContainer>

          <div className="first-frame-policy">
            <div className="policy-main-frame">
              <div className="title-and-slogan">
                <div className="title-policy">{title}</div>
                {slogan && <div className="title-slogan">{slogan}</div>}
              </div>
              {description && (
                <div className="title-description">{description}</div>
              )}
            </div>
          </div>
        </Layout.Content>

        <div className="second-frame-policy">
          <div className="inside-second-policy">
            <div className="policy-content">
              <ReactMarkdown>{policyData.content}</ReactMarkdown>
            </div>
          </div>
        </div>
      </Layout.Page>
    </div>
  );
};

export default Policy;